import Collection from 'fhir/general/Collection';
import React from 'react';
import { checkIfEmpty } from '../utils';
import ContactInfo from './ContactInfo';

export type Props = {
  data: any;
  onChange: (data: any) => void;
  onValidate: (isValid: boolean) => void;
  title: string;
  isRequired?: boolean;
};

const MultipleContactInfo: React.FC<Props> = ({
  data,
  onChange,
  onValidate,
  title,
  isRequired = false
}) => {
  const isEmpty = (contactInfo) => {
    if (checkIfEmpty(contactInfo).length === 0) return false;
    else return checkIfEmpty(contactInfo).some((entry) => entry === true);
  };

  return (
    <Collection
      data={data}
      isItemEmpty={isEmpty}
      onChange={onChange}
      onValidate={onValidate}
      page={ContactInfo}
      showRemoveForFirstEntry={true}
      title={title}
      minItems={1}
      required={isRequired}
    />
  );
};

export default React.memo(MultipleContactInfo);
